import {
	BarChartOutlined,
	CheckCircleFilled,
	SafetyOutlined,
	TeamOutlined,
} from "@ant-design/icons";
import { Typography } from "antd";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthStore } from "@/modules/auth/store/auth.store";

const { Title, Text } = Typography;

const features = [
	{ icon: <TeamOutlined />, text: "O'quvchi va xodimlarni boshqarish" },
	{ icon: <BarChartOutlined />, text: "Davomat va hisobotlar tizimi" },
	{ icon: <SafetyOutlined />, text: "Face ID orqali identifikatsiya" },
];

export function AuthLayout() {
	const isAuthenticated = useAuthStore((state) => state.isAuthenticated);

	if (isAuthenticated) {
		return <Navigate to="/dashboard" replace />;
	}

	return (
		<div className="flex min-h-screen">
			{/* Left branding panel */}
			<div
				className="hidden md:flex flex-col justify-center px-12 lg:px-16"
				style={{
					width: "55%",
					background: "linear-gradient(135deg, #101828 0%, #1a3a5c 50%, #1677b3 100%)",
				}}
			>
				<div className="max-w-md">
					<img src="/logo.png" alt="Logo" className="h-10 mb-8 brightness-0 invert" />
					<Title level={2} style={{ color: "#ffffff", marginBottom: 8, fontWeight: 600 }}>
						Maktab boshqaruv tizimi
					</Title>
					<Text style={{ color: "rgba(255,255,255,0.6)", fontSize: 15, lineHeight: 1.7 }}>
						Zamonaviy ta'lim muassasalarini samarali boshqarish platformasi
					</Text>

					<div className="mt-10 flex flex-col gap-4">
						{features.map((feature) => (
							<div key={feature.text} className="flex items-center gap-3">
								<span
									style={{
										display: "inline-flex",
										alignItems: "center",
										justifyContent: "center",
										width: 36,
										height: 36,
										borderRadius: 8,
										background: "rgba(255,255,255,0.08)",
										color: "rgba(255,255,255,0.8)",
										fontSize: 16,
									}}
								>
									{feature.icon}
								</span>
								<Text style={{ color: "rgba(255,255,255,0.75)", fontSize: 14 }}>
									{feature.text}
								</Text>
							</div>
						))}
					</div>

					<div className="mt-12 flex items-center gap-2">
						<CheckCircleFilled style={{ color: "#389e6e", fontSize: 13 }} />
						<Text style={{ color: "rgba(255,255,255,0.4)", fontSize: 12 }}>
							Xavfsiz va ishonchli tizim
						</Text>
					</div>
				</div>
			</div>

			{/* Right form panel */}
			<div
				className="flex-1 flex items-center justify-center p-6"
				style={{ background: "#ffffff" }}
			>
				<Outlet />
			</div>
		</div>
	);
}
